import enCa from '@worktango/translations/full/en-ca.json';
import frCa from '@worktango/translations/full/fr-ca.json';
import esEs from '@worktango/translations/full/es-es.json';

const translations = {
  'en-ca': enCa,
  'fr-ca': frCa,
  'es-es': esEs,
};

export default translations;
